<template>
  <Dialog :commonDialog="dialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex> Manage Designation</v-flex>
        <v-flex class="text-right">
          <v-btn
           small
           class="mx-4"
           @click="addDesignation"
           >
            <span class="font-size-16 font-weight-600">Add Designation</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative"
      >
        <v-container class="py-0">
          <v-row class="py-0">
            <v-col md="12" class="py-0">
              <table class="width-100">
                <tbody>
                  <tr v-for="(type, index) in user_designation" :key="index">
                    <td>
                      <v-text-field
                        v-model.trim="type.text"
                        dense
                        filled
                        label="Designation"
                        solo
                        flat
                        class="px-4 py-2"
                        hide-details
                        :disabled="pageLoading"
                        :loading="pageLoading"
                        color="cyan"
                      ></v-text-field>
                    </td>
                    <td width="50">
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-on:click="deleteContractType(index)"
                            color="deep-orange"
                            v-bind="attrs"
                            v-on="on"
                            >mdi-delete</v-icon
                          >
                        </template>
                        <span>Click here to delete</span>
                      </v-tooltip>
                    </td>
                  </tr>
                  <v-alert
                        v-if="duplicateDesignationMessage"
                          type="error"
                          dense
                          outlined
                        >
                        {{ duplicateDesignationMessage }}
                  </v-alert>
                </tbody>
              </table>
            </v-col>
          </v-row>
        </v-container>
      </perfect-scrollbar>
    </template>
    <template v-slot:action>
      <v-btn
        :disabled="pageLoading || isSaveDisabled"
        :loading="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="updateContractSetting"
      >
        Save
      </v-btn>
      <v-btn
        :disabled="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close-dialog', true)"
        @click="closeDesignation"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import { PATCH } from "@/core/services/store/request.module";
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    e_designation: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
  },
  watch: {
    e_designation: {
      deep: true,
      immediate: true,
      handler(param) {
        this.user_designation = param;
      },
    },
  },
  data: () => {
    return {
      pageLoading: false,
      error:[],
      user_designation: [
        {
          title: null,
        },
      ],
    };
  },
  methods: {
    updateContractSetting() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "setting/customer-designation",
          data: { customer_designation: _this.user_designation },
        })
        .then(() => {
          _this.$emit("close-dialog", true);
          _this.$emit("get-e-designation", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    createContractType() {
      this.user_designation.push({
        value: null,

      });
    },
    addDesignation() {
     const list = this.user_designation; 

     if (!list || list.length === 0) {
       this.user_designation.push({ text: "" });
       return;
      }

      const lastRow = list[list.length - 1];
      const isInvalid =
     !lastRow.text ||
      lastRow.text.trim() === "";

     if (isInvalid) {
     ErrorEventBus.$emit(
              "update:error",
              InitializeError("Please fill the privious designation first.")
            );
      return;
    }
  
     this.user_designation.push({ text: "" });
    },

    closeDesignation() {
      const list = this.user_designation;

      if (!list || list.length === 0) return;

      const lastRow = list[list.length - 1];

      if (!lastRow.text || lastRow.text.trim() === "") {
        this.user_designation.pop(); 
      }
    },
    deleteContractType(index) {
      if (this.user_designation.length > 1) {
        this.user_designation.splice(index, 1);
      }
    },
  },
  components: {
    Dialog,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },

    duplicateDesignationMessage() {

    const texts = this.user_designation
      .map(item => item.text?.trim().toLowerCase())
      .filter(Boolean);

    const duplicate = texts.find(
      (text, index) => texts.indexOf(text) !== index
    );

    return duplicate ? "Designation already exists." : "";
  },


    isSaveDisabled() {
    // disable on empty text  
    const hasEmpty = this.user_designation.some(
      (item) => !item.text || item.text.trim() === ""
    );
    if (hasEmpty) return true;
 
    // Disable if there are duplicate designation texts
    const texts = this.user_designation.map((item) =>
      item.text.trim().toLowerCase()
    );
    const hasDuplicate = texts.some(
      (text, index) => texts.indexOf(text) !== index
    );
    if (hasDuplicate) return true;
 
    return false;
  },

},
};

</script>
